import Container from '../ui/Container';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import StatCounter from '../ui/StatCounter';
import Icon from '../ui/Icon';
import { impactStats } from '../../data/stats';

/** Dashboard-style impact cards with counters that animate into view. */
export default function ImpactStats() {
  return (
    <section className="relative overflow-hidden bg-ink-950 py-20 sm:py-24" id="impact">
      <div className="pointer-events-none absolute inset-0 bg-grid bg-grid-cell opacity-60" aria-hidden="true" />
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-brand-600/20 blur-[120px]"
        aria-hidden="true"
      />

      <Container className="relative">
        <SectionHeading
          eyebrow="Measured impact"
          tone="dark"
          title="Numbers our clients report in their ESG filings"
          description="Every consignment converts into recovered material and avoided emissions. These are the cumulative figures across our operating history."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {impactStats.map((stat, index) => (
            <Reveal key={stat.id} delay={index * 0.07}>
              <div className="group h-full rounded-xl2 border border-white/10 bg-white/[0.04] p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-400/40 hover:bg-white/[0.07]">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-500/15 text-brand-300 transition-colors duration-300 group-hover:bg-brand-500 group-hover:text-white">
                  <Icon name={stat.icon} className="h-5 w-5" />
                </span>
                <p className="mt-6 font-display text-3xl font-bold text-white">
                  <StatCounter value={stat.value} suffix={stat.suffix} />
                </p>
                <p className="mt-2 text-sm font-semibold text-brand-200">{stat.label}</p>
                <p className="mt-1.5 text-xs leading-relaxed text-ink-500">{stat.caption}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
